import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const validation = Yup.object().shape({
  paymentMode: Yup.string().required("Please Select Payment Method*"),
});

export default { resolver: yupResolver(validation) };
